import React from 'react'


const AddButton = ({label, ...props}) => {
  return (
    <div 
    className='device-btn' 
    {...props}>
            <span className='device-btn-text'>{label}</span>                                               
    </div>
  )
}

export default AddButton
